import {
  IFilterData,
  IGetFilterProps,
  IGetUniqueData,
} from "interfaces/FilterProps";
import {
  IGuestProviderCreateProps,
  IProvider,
  IProviderCreateProps,
  IProviderEditProps,
} from "interfaces/Provider";
import { client } from "./api";

export async function getProviders({
  order,
  relations,
  skip,
  take,
  where,
}: IGetFilterProps<IProvider>): Promise<IFilterData<IProvider>> {
  const api = client();
  const response = await api.get<IFilterData<IProvider>>("providers", {
    params: {
      take,
      skip,
      relations: JSON.stringify(relations),
      order: JSON.stringify(order),
      where: JSON.stringify(where),
    },
  });
  return response.data;
}
export async function getProvidersService(): Promise<IFilterData<IProvider>> {
  const api = client();
  const response = await api.get<IFilterData<IProvider>>("providers");
  if (!response) {
    throw new Error();
  }
  return response.data;
}

export async function getProviderService(
  id: string
): Promise<IGetUniqueData<IProvider>> {
  const api = client();
  const response = await api.get<IGetUniqueData<IProvider>>(`providers/one`, {
    params: {
      where: { id },
      relations: {
        user: true,
        services: true,
      },
    },
  });

  return response.data;
}

export async function searchProvidersService(
  query: string
): Promise<IFilterData<IProvider>> {
  const api = client();
  const response = await api.get<IFilterData<IProvider>>(
    `providers?filter=${query}`
  );
  return response.data;
}

export async function createGuestProviderService({
  name,
  cnpj,
  tradingName,
  managerName,
  cpf,
  email,
  password,
  rg,
  tenantId,
}: IGuestProviderCreateProps) {
  const api = client();

  return await api.post("providers/guest", {
    provider: {
      name,
      tradingName,
      managerName,
    },
    user: {
      name,
      cnpj,
      cpf,
      email,
      password,
      rg,
    },
    tenantId,
  });
}

export async function createProvidersService({
  name,
  cnpj,
  tradingName,
  managerName,
  cpf,
  email,
  password,
  rg,
  services
}: IProviderCreateProps) {
  const api = client();
  const response = await api.post("providers", {
    provider: {
      name,
      tradingName,
      managerName,
    },
    user: {
      name,
      cnpj,
      cpf,
      email,
      password,
      rg,
    },
    services
  });
  return response.data;
}

export async function updateProvidersService({
  userId,
  cpf,
  email,
  name,
  rg,
  providerId,
  cnpj,
  corporativeEmail,
  managerName,
  tradingName,
  services
}: IProviderEditProps) {
  const api = client();
  const response = await api.patch("providers", {
    provider: {
      id: providerId,
      corporativeEmail,
      managerName,
      tradingName,
      name,
    },
    user: {
      id: userId,
      cpf,
      cnpj,
      email,
      name,
      rg,
    },
    services
});
  return response.data;
}

export async function activeProvider(id: string) {
  const api = client();
  const response = await api.post(`providers/${id}`);
  return response.data;
}

export async function deleteProvider(id: string) {
  const api = client();
  const response = await api.delete(`providers/${id}`);
  return response.data;
}
